export default __webpack_public_path__ + "static/media/AKM_5.02a37181.png";